/** @format */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { UIRouterModule } from '@uirouter/angular';
import { SisCommonModule } from 'sis-common';
import { SisComponentsModule } from 'sis-components';
import { StudentCommonModule } from '../common/common.module';
import { TutoringPlansComponent } from './tutoring-plans/tutoring-plans.component';
import { tutoringStates } from './tutoring.route-ng';

@NgModule({
    declarations: [TutoringPlansComponent],
    imports: [
        BrowserModule,
        SisCommonModule,
        SisComponentsModule,
        StudentCommonModule,
        TranslateModule.forChild(),
        UIRouterModule.forChild({ states: tutoringStates }),
    ],
})
export class TutoringModule {}
